import { User } from "oidc-client-ts";

export function getUser() {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${import.meta.env.VITE_APP_OIDC_AUTHORITY}:${
      import.meta.env.VITE_APP_OIDC_CLIENTID
    }`,
  );
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

const PushNotificationsController = (function () {
  function urlB64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  return {
    retrievePublicKey: function () {
      return fetch(
        `${import.meta.env.VITE_APP_API_URL}/push-notifications/public-key`,
      ).then(function (response) {
        if (response.ok) {
          return response
            .text()
            .then(function (applicationServerPublicKeyBase64) {
              return urlB64ToUint8Array(applicationServerPublicKeyBase64);
            });
        } else {
          return Promise.reject(response.status + " " + response.statusText);
        }
      });
    },
    storePushSubscription: function (pushSubscription) {
      const user = getUser();
      const token = user?.access_token;

      return fetch(
        `${import.meta.env.VITE_APP_API_URL}/push-notifications/subscriptions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(pushSubscription),
        },
      );
    },
    discardPushSubscription: function (pushSubscription) {
      return fetch(
        `${
          import.meta.env.VITE_APP_API_URL
        }/push-notifications/subscriptions?endpoint=` +
          encodeURIComponent(pushSubscription.endpoint),
        {
          method: "DELETE",
        },
      );
    },
  };
})();

export class PushNotifications {
  static applicationServerPublicKey;
  static pushServiceWorkerRegistration;

  static initSW(): void {
    const t = this;
    window.addEventListener("load", () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/pushsw.js")
          .then(function (serviceWorkerRegistration) {
            t.pushServiceWorkerRegistration = serviceWorkerRegistration;

            console.log("Push Service Worker has been registered successfully");
          })
          .catch(function (error) {
            console.error(
              "Push Service Worker registration has failed: " + error,
            );
          });
      }
    });
  }

  static subscribeForPushNotifications(callback?: () => void) {
    const t = this;
    if (t.applicationServerPublicKey) {
      t.subscribeForPushNotificationsInternal();
    } else {
      PushNotificationsController.retrievePublicKey()
        .then(function (retrievedPublicKey) {
          t.applicationServerPublicKey = retrievedPublicKey;
          console.log("Successfully retrieved Public Key");

          t.subscribeForPushNotificationsInternal();
          callback?.();
        })
        .catch(function (error) {
          console.error("Failed to retrieve Public Key: " + error);
        });
    }
  }

  static subscribeForPushNotificationsInternal() {
    const t = this;

    t.pushServiceWorkerRegistration.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: t.applicationServerPublicKey,
      })
      .then(function (pushSubscription) {
        PushNotificationsController.storePushSubscription(pushSubscription)
          .then(function (response) {
            if (response.ok) {
              console.log("Successfully subscribed for Push Notifications");
            } else {
              console.error(
                "Failed to store the Push Notifications subscrition on server",
              );
            }
          })
          .catch(function (error) {
            console.error(
              "Failed to store the Push Notifications subscrition on server: " +
                error,
            );
          });
      })
      .catch(function (error) {
        if (Notification.permission === "denied") {
        } else {
          console.error("Failed to subscribe for Push Notifications: " + error);
        }
      });
  }

  static unsubscribeFromPushNotifications() {
    const t = this;

    t.pushServiceWorkerRegistration.pushManager
      .getSubscription()
      .then(function (pushSubscription) {
        if (pushSubscription) {
          pushSubscription
            .unsubscribe()
            .then(function () {
              PushNotificationsController.discardPushSubscription(
                pushSubscription,
              )
                .then(function (response) {
                  if (response.ok) {
                    console.log(
                      "Successfully unsubscribed from Push Notifications",
                    );
                  } else {
                    console.error(
                      "Failed to discard the Push Notifications subscrition from server",
                    );
                  }
                })
                .catch(function (error) {
                  console.error(
                    "Failed to discard the Push Notifications subscrition from server: " +
                      error,
                  );
                });
            })
            .catch(function (error) {
              console.error(
                "Failed to unsubscribe from Push Notifications: " + error,
              );
            });
        }
      });
  }
}
